import {
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

export const FreePill = ({ className = '' }) => {
  return (
    <Typography
      weight="semibold"
      className={`co-w-120px co-bg-[#E4F7E0] co-text-[#0D7A26] co-rounded-4px co-py-2px co-px-4px ${className}`}
      color="#0D7A26"
    >
      Producto gratis
    </Typography>
  );
};

export const PreSalePill = ({ className = '' }) => {
  return (
    <div
      className={`co-w-100px co-flex co-gap-4px co-py-2px co-px-4px co-rounded-4px co-items-center co-bg-[#E4F7E0] ${className}`}
    >
      <Icon icon="PresaleIcon" width={20} height={20} />
      <Typography
        weight="semibold"
        className="co-text-[#0D7A26]"
        color="#0D7A26"
      >
        Preventa
      </Typography>
    </div>
  );
};

export const CollabPill = () => {
  return (
    <div
      className={
        'co-flex co-gap-4px co-py-2px co-px-4px co-rounded-4px co-items-center co-bg-white'
      }
    >
      <Typography weight="semibold" className="co-text-pds-tertiary-600">
        Descuento colaborador
      </Typography>
    </div>
  );
};

interface CardPillMessage {
  message: string;
}

export const PromoText = ({ message }: CardPillMessage) => {
  return (
    <p
      className="co-flex co-w-min co-h-[20px] lg:co-h-[24px] co-bg-pds-secondary-600 co-px-4px co-py-2px co-rounded-4px co-shadow-md co-items-center co-font-semibold co-text-body2 co-text-white co-leading-16px co-overflow-hidden co-overflow-ellipsis co-whitespace-nowrap"
      tabIndex={0}
    >
      {message}
    </p>
  );
};
